import React, { useState, forwardRef } from "react"
import DatePicker from "react-datepicker"
import cn from "classnames"

type DatepickerInputProps = {
  onClick?: () => void
  value?: string
  placeholder?: string
  inputClass: string
  children?: React.ReactNode
}

/* Datepicker with Input */
const DatepickerInput = forwardRef<HTMLInputElement, DatepickerInputProps>(
  (props, ref) => {
    const onDateValueChange = () => {}
    return (
      <input
        type="text"
        className={cn("form-control", "date", props.inputClass)}
        onClick={props.onClick}
        value={props.value ? props.value : props.placeholder}
        onChange={onDateValueChange}
        ref={ref}
      />
    )
  }
)

/* Datepicker with Addon Input */
const DatepickerInputWithAddon = forwardRef<
  HTMLInputElement,
  DatepickerInputProps
>((props, ref) => (
  <div className="input-group" ref={ref}>
    <input
      type="text"
      className={cn("form-control", "form-control-light", props.inputClass)}
      onClick={props.onClick}
      value={props.value}
      readOnly
    />
    <div className="input-group-append">
      <span className="input-group-text bg-primary border-primary text-white">
        <i className="ri-calendar-2-line font-13"></i>
      </span>
    </div>
  </div>
))

type HyperDatepickerProps = {
  textValue?: string
  value?: Date
  disabled?: boolean
  onChange: (date: Date) => void
  hideAddon?: boolean
  inputClass?: string
  dateFormat?: string
  minDate?: Date
  maxDate?: Date
  minTime?: Date
  maxTime?: Date
  onCalendarClose?: () => void
  className?: string
  showTimeSelect?: boolean
  tI?: number
  timeFormat?: string
  timeCaption?: string
  showTimeSelectOnly?: boolean
  monthsShown?: number
  inline?: boolean
  selected?: Date
  placeholder?: string
  customDayClass?: (date: Date) => string
}

const inputStyles = {
  maxWidth: 320,
}
const HyperDatepicker = (props: HyperDatepickerProps) => {
  const [value, setValue] = useState<any>(props.value)
  // handle custom input
  const input =
    (props.hideAddon || false) === true ? (
      <DatepickerInput inputClass={props.inputClass!} />
    ) : (
      <DatepickerInputWithAddon inputClass={props.inputClass!} />
    )

  // return (
  //   <DateTimePicker
  //     formatStyle="small"
  //     onChange={(value) => {
  //       setValue(value)
  //       props.onChange && props.onChange(value)
  //     }}
  //     value={value}
  //     placeholder={'Time not set'}
  //     className="rainbow-m-around_small"
  //     style={inputStyles}
  //   />
  // )

  const valueProp = !props.textValue ? {} : { value: props.textValue }

  return (
    <>
      {/* date picker control */}
      <DatePicker
        dayClassName={props.customDayClass}
        onCalendarClose={props.onCalendarClose}
        disabled={props.disabled}
        timeIntervals={props.tI}
        selected={props.value}
        {...valueProp}
        className={cn("form-control", props.inputClass)}
        onChange={(date) => props.onChange(date!)}
        timeFormat={props.timeFormat || "hh:mm a"}
        dateFormat={props.dateFormat || "MM/dd/yyyy"}
        timeCaption={props.timeCaption}
        minDate={props.minDate}
        maxDate={props.maxDate}
        minTime={props.minTime}
        maxTime={props.maxTime}
        monthsShown={props.monthsShown}
        showTimeSelect={props.showTimeSelect}
        showTimeSelectOnly={props.showTimeSelectOnly}
        inline={props.inline}
        placeholderText={props.placeholder || "Time not set"}
      />
    </>
  )
}

export default HyperDatepicker
